import React from 'react';
import { getMessage } from 'util/locale';
import classNames from 'classnames';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import { getAccountCountry } from 'user/selectors';
import {
  isEu9Limited,
  isLatamCountry,
  SUPPORTED_COUNTRIES
} from 'constants/countryCodes';
import { scriptTypes } from 'constants/scripts';
import {
  getCurrentPath,
  isEditRoute as isEditRouteFunc
} from '../routes/selectors';
import { getActiveScriptType } from '../current/selectors';

// components
import FieldInfoContainer from 'common/FieldInfoContainer';

let ScriptCreatorTitle = ({ accountCountry, editRoute, scriptType }) => {
  const baseString = 'vra-script-creator-title';
  const classString = classNames({
    [`${baseString}`]: true
  });
  const disclaimer
    = scriptType === scriptTypes.PLANTING && isEu9Limited(accountCountry) ? (
      <span className={'vra-emea-disclaimer-title'}>
        {getMessage('disclaimer--emea-seed-density')}
      </span>
    ) : null;

  let cpDisclaimer = null;
  if (editRoute && scriptType === scriptTypes.APPLICATION) {
    if (isEu9Limited(accountCountry)) {
      cpDisclaimer = (
        <span className="vra-cp-disclaimer-title">
          {getMessage('label-text__crop-protection-disclaimer--emea')}
        </span>
      );
    } else if (accountCountry === SUPPORTED_COUNTRIES.UNITED_STATES) {
      cpDisclaimer = (
        <span className="vra-cp-disclaimer-title">
          {getMessage('label-text__crop-protection-disclaimer--us')}
        </span>
      );
    } else if (accountCountry === SUPPORTED_COUNTRIES.CANADA) {
      cpDisclaimer = (
        <span className="vra-cp-disclaimer-title">
          {getMessage('label-text__crop-protection-disclaimer--ca')}
        </span>
      );
    } else if (isLatamCountry(accountCountry)) {
      cpDisclaimer = (
        <span className="vra-cp-disclaimer-title">
          {getMessage('label-text__crop-protection-disclaimer--latam')}
        </span>
      );
    }
  }
  return (
    <section className={classString}>
      <header className="vra-script-creator-title__header">
        {getMessage('title-text__script-creator')}
        {disclaimer}
        {cpDisclaimer}
      </header>
      <FieldInfoContainer />
    </section>
  );
};

ScriptCreatorTitle.propTypes = {
  accountCountry: propTypes.object,
  editRoute: propTypes.bool,
  scriptType: propTypes.string
};

ScriptCreatorTitle = connect((state) => {
  const editRoute = isEditRouteFunc(getCurrentPath(state));
  return {
    accountCountry: getAccountCountry(state),
    editRoute,
    scriptType: getActiveScriptType(state)
  };
})(ScriptCreatorTitle);

export default ScriptCreatorTitle;
